import React from 'react';
import {AsyncComponent} from "../../../core/components/router/async-component";

const PlayByPlayWidgetAsyncComponent = AsyncComponent(async () => import('./play-by-play-widget' /* webpackChunkName: "play-by-play-widget" */ ));

export const PlayByPlayWidgetAsync = (props) => {
  return <PlayByPlayWidgetAsyncComponent {...props}/>
};
